// Campus photo for /colleges/illinois-institute-of-technology: Public domain, by Joe Ravi, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3ACrown_Hall_2.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/illinois-institute-of-technology/; credited under the photo.
const photo = {
    "slug": "illinois-institute-of-technology",
    "alt": "S. R. Crown Hall, the glass and steel home of the College of Architecture, on the Illinois Tech campus in Chicago",
    "src": "/colleges/illinois-institute-of-technology/campus-1600.webp",
    "srcSmall": "/colleges/illinois-institute-of-technology/campus-800.webp",
    "srcMid": "/colleges/illinois-institute-of-technology/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/illinois-institute-of-technology/og.jpg",
    "title": "Crown Hall 2",
    "author": "Joe Ravi",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3ACrown_Hall_2.jpg",
    "read": "2026-10-02"
};

export default photo;
